export const PINO_LOGGER_DEFAULTS = {
  level: "info",
};

export const PINO_CUSTOM_CONTEXT_KEY = "custom_context";

export const MAX_LOG_SIZE_IN_BYTES_DEFAULT = 1000 * 1024; // 1MB
